import React from 'react';
import { Field, reduxForm } from 'redux-form'
import { renderField, validate } from '../../helpers/validation.helper';

const AddCommentForm  = props => {
    const { handleSubmit, placeholder } = props;

    return (
        <div>
            <form onSubmit={handleSubmit}>
                    <Field
                        id="comment"
                        name="comment"
                        type="text"
                        placeholder={placeholder ? placeholder : "Adaugă un comentariu..."}
                        component={renderField}
                    />
            </form>
        </div>
    )

};

export default reduxForm({
    form: 'addCommentForm', // a unique identifier for this form,
    validate: validate('addCommentForm')
})(AddCommentForm)


// WEBPACK FOOTER //
// ./src/SHARED/components/comments/addcommentForm.js